import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ProductCategoryDelete as ProductCategoryDeleteMutation,
    ProductCategoryDeleteVariables as ProductCategoryDeleteMutationVariables,
    ProductCategoryDeleteInput,
} from 'nutshell-graphql-types';

import {bustManagedCollectionCache} from '../../../../util/bust-managed-collection-cache';

import DELETE_PRODUCT_CATEGORY from '../mutations/delete-product-category.graphql';
import GET_PRODUCTS_CATEGORIES from '../queries/get-product-categories.graphql';

export function useDeleteProductCategory(): {
    deleteProductCategory: (arg1: ProductCategoryDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [deleteProductCategory, {loading, error}] = useMutation<
        ProductCategoryDeleteMutation,
        ProductCategoryDeleteMutationVariables
    >(DELETE_PRODUCT_CATEGORY);

    return {
        deleteProductCategory: (input: ProductCategoryDeleteInput) => {
            return deleteProductCategory({
                variables: {input},
                update: (proxy, {data}) => {
                    const productCategory =
                        data &&
                        data.productCategoryDelete &&
                        data.productCategoryDelete.productCategory;

                    if (!productCategory) return;

                    const existing = proxy.readQuery({
                        query: GET_PRODUCTS_CATEGORIES,
                    });

                    // @ts-expect-error
                    if (!existing || !existing.productCategories) return;

                    proxy.writeQuery({
                        query: GET_PRODUCTS_CATEGORIES,
                        data: {
                            // @ts-expect-error
                            productCategories: existing.productCategories.filter(
                                // @ts-expect-error
                                (item) => item.id !== productCategory.id
                            ),
                            __typename: 'Query',
                        },
                    });
                },
            }).then((result) => {
                // Ensure REST-backed products lists refresh to include category changes
                bustManagedCollectionCache('products');
                bustManagedCollectionCache('productCategories');

                return (
                    result.data &&
                    result.data.productCategoryDelete &&
                    result.data.productCategoryDelete.productCategory
                );
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
